let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("exxzd")).then(() => parcelRequire('lomTb'));